var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArtisanGrid',{ref:"limit",attrs:{"metaKey":"BasisReserveLimit"},scopedSlots:_vm._u([{key:"patientAge",fn:function({ row }){return [_c('span',[_vm._v(_vm._s(_vm.calcAge(row.patientBirthday)))])]}},{key:"patientPhone",fn:function({ row }){return [_c('span',[_vm._v(_vm._s(_vm.keepSecret(row.patientPhone)))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }